import vHeader from "./v-header.vue";

export default Vue => {
  Vue.component("v-header", vHeader);
};
